import React from 'react';
import { motion } from 'framer-motion';

const Preloader = () => {
  return (
    <motion.div
      initial={{ opacity: 1 }}
      exit={{ opacity: 0, transition: { duration: 3.0, ease: 'easeInOut' } }}
      className="fixed inset-0 z-[9999] flex flex-col items-center justify-center bg-[#05070a]"
    >
      <div className="relative">
        <motion.div
          animate={{
            scale: [1, 1.2, 1],
            rotate: [0, 180, 360],
          }}
          transition={{
            duration: 2,
            repeat: Infinity,
            ease: 'easeInOut',
          }}
          className="w-20 h-20 border-t-4 border-b-4 border-blue-500 rounded-full"
        />
        <div className="absolute inset-0 flex items-center justify-center">
          <img
            src="/images/logo/sera-logo.png"
            alt="Sera Water logo"
            className="w-16 h-16 object-contain"
          />
        </div>
      </div>

      <motion.div
        initial={{ opacity: 0, y: 10 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.5 }}
        className="mt-8 text-center"
      >
        <h2 className="text-white text-lg font-medium tracking-[0.3em] uppercase">Sera Water</h2>
        <div className="mt-2 w-48 h-[2px] bg-white/10 overflow-hidden relative mx-auto">
          <motion.div
            initial={{ left: '-100%' }}
            animate={{ left: '100%' }}
            transition={{ repeat: Infinity, duration: 1.5, ease: 'linear' }}
            className="absolute top-0 h-full w-1/2 bg-gradient-to-r from-transparent via-blue-500 to-transparent"
          />
        </div>
        <p className="text-gray-500 text-xs mt-4">Loading...</p>
      </motion.div>
    </motion.div>
  );
};

export default Preloader;